// extracted by mini-css-extract-plugin
export var about = "index-module--about--6cOvp";
export var contact = "index-module--contact--cYS9y";
export var landing = "index-module--landing--88Mp1";
export var phone = "index-module--phone--jRp0E";